jQuery(document).ready(function()
{
  
  
   setTimeout(function() {
            jQuery(".alert_message").hide();
        }, 10000);
  
  //Comment form validation
  
  function checkEmpty(value) {
					if(!value) {
						return true;
					}
	}
  
  function correctEmail(email) {
				var re = /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
    			return re.test(String(email).toLowerCase());
			}
  
  jQuery(".comment-btn-set .comment_btn ").on('click',function()
  {
 		 var firstname = jQuery("#firstname").val();
    	 var lastname = jQuery("#lastname").val();
      	 var email = jQuery("#comment_email").val();
         var website = jQuery("#comment_website").val();
      	 var comment_body = jQuery("#comment_body").val();
    var filter= /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{3})$/;
    var flag=0;
    
    var firstnameError = true;
    var lastnameError = true;
    var emailError = true;
    var websiteError = true;
    var comment_bodyError = true;
    firstnameError = checkEmpty(firstname);
     lastnameError = checkEmpty(lastname);
    emailError = checkEmpty(email);
    websiteError = checkEmpty(website);
    comment_bodyError = checkEmpty(comment_body);
    if(emailError) {
					var hasEmail = correctEmail();
					emailError = !hasEmail;
				}
    
    if(firstnameError)
	{
			jQuery("#firstname").addClass('error');
			//$('.with-errors').html('<span class="error" style="color:red">Please Enter Position</span>');
						//$('html, body').animate({scrollTop:$("#position_applied").position().top}, 'slow');
	}
	else
	{
			jQuery("#firstname").removeClass('error');
				//$('.with-errors').html("");
	}
    if(lastnameError)
	{
      jQuery("#lastname").addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery("#lastname").removeClass('error');
     // $('.lname').html("");

    }
     if(emailError)
	{
      jQuery("#comment_email").addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery("#comment_email").removeClass('error');
     // $('.lname').html("");

    }
     if(websiteError)
	{
      jQuery("#comment_website").addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery("#comment_website").removeClass('error');
     // $('.lname').html("");

    }
    
     if(comment_bodyError)
	{
      jQuery("#comment_body").addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery("#comment_body").removeClass('error');
     // $('.lname').html("");

    }
		
    if(websiteError == true || comment_bodyError == true || firstnameError == true || lastnameError == true ||  emailError == true  ) {
    jQuery('.alert-error').show();
      jQuery('#some-error').html("One or more fields have an error. Please check and try again.");
			
			setTimeout(function() {
									jQuery(".alert-error").hide();
								}, 10000);
      return false;
    
    }else
    {
      return true;
    }
  });
  //Account adresses form validation 
 jQuery(".action_bottom .add_submit ").on('click',function(e)
  {
    // e.preventDefault();
 		 var firstname = jQuery(".add_firstname").val();
    	 var lastname = jQuery(".add_lastname").val();
      	 var company = jQuery(".add_company").val();
         var phone = jQuery(".add_phone").val();
      	 var address = jQuery(".add_address1").val();
      var city = jQuery(".add_city").val();
      var zipcode = jQuery(".add_zip").val();
   
    var flag=0;
    
    var firstnameError = true;
    var lastnameError = true;
    var companyError = true;
    var phoneError = true;
    var addressError = true;
      var cityError = true;
     var zipcodeError = true;
    firstnameError = checkEmpty(firstname);
     lastnameError = checkEmpty(lastname);
    companyError = checkEmpty(company);
    phoneError = checkEmpty(phone);
    addressError = checkEmpty(address);
     cityError = checkEmpty(city);
      zipcodeError = checkEmpty(zipcode);
   
    
    if(firstnameError)
	{
			jQuery(".add_firstname").addClass('error');
			//$('.with-errors').html('<span class="error" style="color:red">Please Enter Position</span>');
						//$('html, body').animate({scrollTop:$("#position_applied").position().top}, 'slow');
	}
	else
	{
			jQuery(".add_firstname").removeClass('error');
				//$('.with-errors').html("");
	}
    if(lastnameError)
	{
      jQuery(".add_lastname").addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery(".add_lastname").removeClass('error');
     // $('.lname').html("");

    }
     if(companyError)
	{
      jQuery(".add_company").addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery(".add_company").removeClass('error');
     // $('.lname').html("");

    }
     if(phoneError)
	{
      jQuery(".add_phone").addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery(".add_phone").removeClass('error');
     // $('.lname').html("");

    }
    
     if(addressError)
	{
      jQuery(".add_address1").addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery(".add_address1").removeClass('error');
     // $('.lname').html("");

    }
	
      if(cityError)
	{
      jQuery(".add_city").addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery(".add_city").removeClass('error');
     // $('.lname').html("");

    }
     if(zipcodeError)
	{
      jQuery(".add_zip").addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery(".add_zip").removeClass('error');
     // $('.lname').html("");

    }
     
    if(zipcodeError == true || cityError == true || firstnameError == true 
	|| lastnameError == true ||  companyError == true || addressError == true
      || phoneError ==  true ) {
    jQuery('#alert-error').show();
      jQuery('#alert-error').html("One or more fields have an error. Please check and try again.");
						//$('html, body').animate({scrollTop:$("#scroll_top").position().top-50}, 'slow');
						setTimeout(function() {
									jQuery("#alert-error ").hide();
								}, 10000);
    
      return false;
    
    }else
    {
     
      return true;
    }
  });
  
  jQuery(".action_bottom .edit_submit ").on('click',function(e)
  {
     
 		 var firstname = jQuery(this).parent().prev().find('.edit_firstname').val();
    	 var lastname =jQuery(this).parent().prev().find('.edit_lastname').val();
      	 var company = jQuery(this).parent().prev().find('.edit_company').val();
         var phone = jQuery(this).parent().prev().find('.edit_phone').val();
      	 var address = jQuery(this).parent().prev().find('.edit_address1').val();
      var city = jQuery(this).parent().prev().find('.edit_city').val();
      var zipcode = jQuery(this).parent().prev().find('.edit_zip').val();
   
    var flag=0;
    
    var firstnameError = true;
    var lastnameError = true;
    var companyError = true;
    var phoneError = true;
    var addressError = true;
      var cityError = true;
     var zipcodeError = true;
    firstnameError = checkEmpty(firstname);
     lastnameError = checkEmpty(lastname);
    companyError = checkEmpty(company);
    phoneError = checkEmpty(phone);
    addressError = checkEmpty(address);
     cityError = checkEmpty(city);
      zipcodeError = checkEmpty(zipcode);
   
    
    if(firstnameError)
	{
			jQuery(this).parent().prev().find('.edit_firstname').addClass('error');
			//$('.with-errors').html('<span class="error" style="color:red">Please Enter Position</span>');
						//$('html, body').animate({scrollTop:$("#position_applied").position().top}, 'slow');
	}
	else
	{
			
      jQuery(this).parent().prev().find('.edit_firstname').removeClass('error');
				//$('.with-errors').html("");
	}
    if(lastnameError)
	{
      jQuery(this).parent().prev().find('.edit_lastname').addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
     jQuery(this).parent().prev().find('.edit_lastname').removeClass('error');
     // $('.lname').html("");

    }
     if(companyError)
	{
     jQuery(this).parent().prev().find('.edit_company').addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery(this).parent().prev().find('.edit_company').removeClass('error');
     // $('.lname').html("");

    }
     if(phoneError)
	{
      jQuery(this).parent().prev().find('.edit_phone').addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery(this).parent().prev().find('.edit_phone').removeClass('error');
     // $('.lname').html("");

    }
    
     if(addressError)
	{
      jQuery(this).parent().prev().find('.edit_address1').addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
     jQuery(this).parent().prev().find('.edit_address1').removeClass('error');
     // $('.lname').html("");

    }
	
      if(cityError)
	{
      jQuery(this).parent().prev().find('.edit_city').addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery(this).parent().prev().find('.edit_city').removeClass('error');
     // $('.lname').html("");

    }
     if(zipcodeError)
	{
      jQuery(this).parent().prev().find('.edit_zip').addClass('error');
     // $('.lname').html('<span class="error" style="color:red">Please Enter Lastname</span>');
      //$('html, body').animate({scrollTop:$("#lastname").position().top}, 'slow');
						
	}
	else
    {
      jQuery(this).parent().prev().find('.edit_zip').removeClass('error');
     // $('.lname').html("");

    }
     
    if(zipcodeError == true || cityError == true || firstnameError == true 
	|| lastnameError == true ||  companyError == true || addressError == true
      || phoneError ==  true ) {
    jQuery(this).parent().next().show();
      jQuery(this).parent().next().html("One or more fields have an error. Please check and try again.");
						//$('html, body').animate({scrollTop:$("#scroll_top").position().top-50}, 'slow');
						setTimeout(function() {
									jQuery("#edit-alert-error").hide();
								}, 10000);
      return false;
    
    }else
    {
      return true;
    }
  });
 
 //success messgae wripe out
  setTimeout(function() {
            jQuery(".alert-success").hide();
        }, 10000);
  
   //Active class
  //alert( window.location.pathname);

 var get_pathname = window.location.pathname;
  jQuery('ul.acc-tabs li > a[href="'+get_pathname +'"]').parent().addClass('active');
   jQuery('ul.list-unstyled  li > a[href="'+get_pathname +'"]').parent().addClass('active');
  
  //video popup(home page)
  jQuery('.map-image').fancybox({
	'width':800,
	'height':500,
	'autoSize' : false
	});
	jQuery(window).scroll(function(){
	  var sticky = jQuery('body'),
		  scroll = jQuery(window).scrollTop();

	  if (scroll >= 200) sticky.addClass('sticky_header');
	  else sticky.removeClass('sticky_header');
	}); 
  //newsletter messages hide (home page)
  jQuery('#mc-embedded-subscribe').click(function()
  {
     setTimeout(function(){jQuery('#mce-success-response').hide();},10000);
  setTimeout(function(){jQuery('#mce-error-response').hide();},10000);
   
  //setTimeout(function(){jQuery('.mc-field-group div.mce_inline_error').hide();},10000);
  });
 //career page button js
   /*jQuery('.career_blocks .apply_click a').click(function()
   {
    jQuery(this).parent().next().show();
    jQuery(this).hide();
   });*/
  
  jQuery('.career_blocks .apply_click .apply_btn').click(function(e)
                             {
    
    e.preventDefault();
                               //jQuery('.career_form').insertAfter(jQuery(this).paranet().next());
                               //jQuery('.career_form').show();
                               //jQuery(this).addClass('test');
                               jQuery('.career_form').insertAfter(jQuery(this).parent());
                          jQuery('.career_form').show();
    jQuery(this).hide();
    jQuery('.apply_btn').not(this).show();
                             });
  jQuery('.thumbnails').owlCarousel({
				loop:true,
				lazyLoad:true,
				margin:11,
				//autoplay:true,
				responsiveClass:true,
				responsive:{
					0:{
						items:1,
						nav:true
					},
					600:{
						items:2,
						nav:true
					},
					1000:{
						items:4,
						nav:true,
						loop:true
					}
				}
			});
  
  var width = jQuery(window).width();
  
  if(width <= 767 )
  {
          jQuery('#why_choose_us .row').owlCarousel({
				loop:true,
				lazyLoad:true,
				//margin:27,
				//autoplay:true,
				responsiveClass:true,
				responsive:{
					0:{
						items:1,
						nav:true
					},
					600:{
						items:2,
						nav:true
					},
					1000:{
						items:4,
						nav:true,
						loop:true
					}
				}
			});
    		jQuery('#how_it_work .row').owlCarousel({
				loop:true,
				lazyLoad:true,
				//margin:27,
				//autoplay:true,
				responsiveClass:true,
				responsive:{
					0:{
						items:1,
						nav:true
					},
					600:{
						items:2,
						nav:true
					},
					1000:{
						items:4,
						nav:true,
						loop:true
					}
				}
			});
        }
  
  
	$('.slide-banner ,.footer_top_section').mousemove(function(e){
		
		var wx = $(window).width();
		var wy = $(window).height();
		
		var x = e.pageX - this.offsetLeft;
		var y = e.pageY - this.offsetTop;
		
		var newx = x - wx/2;
		var newy = y - wy/2;
		
		
		$('#wrapper_animation div').each(function(){
			var speed = $(this).attr('data-speed');
			if($(this).attr('data-revert')) speed *= -1;
			TweenMax.to($(this), 1, {x: (1 - newx*speed), y: (1 - newy*speed)});
			
		});
		
	});
  
jQuery(".btn-navbar").click(function(){
	jQuery("html").toggleClass("toggle_menu");
});
jQuery('.nav_close button').click(function(){
	jQuery('html').removeClass('toggle_menu');
});
  
  
  //faq page section js
  
  jQuery(document).on('click','.que_ans .question ',function(){
    if(jQuery(this).parent().hasClass('show_answer'))
    {
      jQuery(this).parent().removeClass('show_answer');
    }else
    {
       jQuery('.que_ans').removeClass('show_answer');
 jQuery(this).parent().addClass('show_answer');
    }
 
  });
  
  jQuery(document).on('click','.boxContainer .main_title_faq ',function(){
   // alert(jQuery(this).parent().hasClass('show_box'));
    if(jQuery(this).parent().hasClass('show_box'))
    {
      jQuery(this).parent().removeClass('show_box');
    }else
    {
        jQuery('.boxContainer').removeClass('show_box');
 jQuery(this).parent().addClass('show_box');
    }
  
   //jQuery( ".boxContainer" ).not(this).addClass( "show_box" );
  });

  	jQuery("h3.main_title_faq").each(function(){
  jQuery(this).nextUntil("h3.main_title_faq").andSelf().wrapAll('<div class="boxContainer"></div>')
});
  
   
   jQuery(".faq_blocks .boxContainer").wrapInner(jQuery("<div class='all_ques_ans'>"));
	jQuery('div.all_ques_ans').each(function(){
 		 jQuery(this).children().first().prependTo(jQuery(this).closest(".boxContainer"));
	});
                      



  
  jQuery('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		jQuery('ul.tabs li').removeClass('current');
		jQuery('.tab-content').removeClass('current');

		jQuery(this).addClass('current');
		jQuery("#"+tab_id).addClass('current');
	});
 jQuery('.banner_section').insertAfter('.page-top .container .page-title');
   function GetURLParameter(sParam){
var sPageURL = window.location.search.substring(1);
var sURLVariables = sPageURL.split('&');
for (var i = 0; i < sURLVariables.length; i++){
var sParameterName = sURLVariables[i].split('=');
if (sParameterName[0] == sParam){
return sParameterName[1];
}
}
}
  var name = GetURLParameter('product_id');
  console.log(name);
//console.log(jQuery("/products/paradeyes-original?product_id=1600916062281").val(getParameterByName("product_id")));
  function reChargeProcessCart() {
	function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
	do {
      		token=get_cookie('cart');
	}
	while(token == undefined);

	var myshopify_domain='{{ shop.permanent_domain }}'
	try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
	var customer_param = '{% if customer %}customer_id={{customer.id}}&customer_email={{customer.email}}{% endif %}'
	checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+"&"+customer_param;
}
   document.addEventListener('DOMContentLoaded', function() {
    var elems = document.querySelectorAll('select');
    var instances = M.FormSelect.init(elems, options);
  });

  // Or with jQuery

  $(document).ready(function(){
    $('select').formSelect();
  });
  
  $('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})
  
  jQuery('.left_commom_select li').click(function()
	{
     var select_pre = jQuery(this).html();
    
    var select_val = jQuery(this).data('value');
    jQuery('#lefteye').val(select_val);
                                    jQuery('.left_value').html(select_pre);
    jQuery('#product-left-power').val(select_pre);
    jQuery(this).parent().parent().parent().parent().removeClass('active');
    if( jQuery('.right_value').html() != jQuery('.left_value').html())
       {
         
			jQuery("#add-to-cart-trial-v3").removeAttr("disabled");
       }
                                  });
  
  jQuery('.right_commom_select li').click(function()

                                  {
     var select_val = jQuery(this).data('value');
    jQuery('#righteye').val(select_val);
                                    var select_pre = jQuery(this).html();
                                    jQuery('.right_value').html(select_pre);
     jQuery('#product-right-power').val(select_pre);
     jQuery(this).parent().parent().parent().parent().removeClass('active');
      if( jQuery('.right_value').html() != jQuery('.left_value').html())
       {
         
			jQuery("#add-to-cart-trial-v3").removeAttr("disabled");
       }
                                  });
  jQuery('.left_area .waves-light').click(function()
  {
    jQuery(this).parent().parent().parent().addClass('active');
  });
   jQuery('.right_area .waves-light').click(function()
  {
    jQuery(this).parent().parent().parent().addClass('active');
  });
  jQuery('#left-power-select .close').click(function()
   {
    jQuery(this).parent().parent().removeClass('active');
  });
   jQuery('#right-power-select .close').click(function()
   {
    jQuery(this).parent().parent().removeClass('active');
  });
   jQuery('.left_area .left_btn').on('click',function()
	{
		jQuery('.right_area').removeClass('active');
	});
	jQuery('.right_area .right_btn').on('click',function()
	{
		jQuery('.left_area').removeClass('active');
	});
 	jQuery('.left_required .not-required').click(function()
    {
			jQuery('.left_value').html('N/A');
      var select_val = jQuery('.left_value').html();
      jQuery('#lefteye').val(select_val);
     if( jQuery('.right_value').html() == jQuery('.left_value').html())
       {
			jQuery("#add-to-cart-trial-v3").attr("disabled","disabled");
       }
    });
  	jQuery('.right_required .not-required').click(function()
    {
			jQuery('.right_value').html('N/A');
    var select_val = jQuery('.right_value').html();
      jQuery('#righteye').val(select_val);
      if( jQuery('.right_value').html() == jQuery('.left_value').html())
       {
         
			jQuery("#add-to-cart-trial-v3").attr("disabled","disabled");
       }
    });
  

});

//jQuery(window).load(function(){
/*
 var get_pathname= window.location.pathname;
jQuery("#header_nav .horizontal-mega-menu a[href='"+get_pathname+"']").parent("li").addClass("active-menu-class").parents("ul.mm-submenu").addClass("submenu-opened");
jQuery("#header_nav .horizontal-mega-menu .submenu-opened").parents("li.buddha-menu-item").addClass("mm-hovering");
*/
//});
